module.exports = __webpack_public_path__ + "static/media/Maf_FGR.4f388d4f.jpg";